export default __webpack_public_path__ + "static/media/concept.98a9952c.svg";